import { fromJS } from 'immutable';

import { GROWLER__HIDE, GROWLER__SHOW } from './constants';

const initialState = fromJS({
  text: '',
  type: '',
  status: 'hidden',
});

export default function growlerReducer(state = initialState, action) {
  switch (action.type) {
    case GROWLER__SHOW:
      return state
        .set('text', action.text)
        .set('status', 'show')
        .set('action', action.action);

    case GROWLER__HIDE:
      return state
        .set('text', '')
        .set('status', 'hide');

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/containers/Notification/reducer.js